import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ScrollToTop } from "@/components/SmoothScroll";
import { Toaster } from "@/components/ui/sonner";

export default function Layout() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  return (
    <div className="bg-slate-50 min-h-screen flex flex-col">
      <ScrollToTop />
      <Navbar />
      <main className={isHome ? "" : "pt-[72px]"}>
        <Outlet />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}
